<template>
  <div class="pb-5" data-wizard-type="step-content">
    <h4 class="mb-10 font-weight-bold text-dark">
      {{
        !!video.videoPath
          ? "Saisissez les informations à modifier en Anglais"
          : "Saisissez les informations à créer en Anglais"
      }}
    </h4>
    <div class="form-group">
      <v-text-field
        type="text"
        v-model="video.titleEN"
        label="Titre de la vidéo *"
            :rules="titleErrors"

      />
    </div>
    <div class="form-group">
      <v-textarea
        v-model="video.descriptionEN"
        label="Description de la vidéo *"
        value="25"
            :rules="descErrors"

      />
    </div>

    <div class="form-text">Tags / Mots-clés de la vidéo *</div>
    <div class="row">
      <div class="col-xl-6">
        <div class="form-group">
          <label><i class="la la-eye"></i> Visibles</label>

          <v-combobox
            v-model="video.keywords.visibleEN"
            :items="keywords.visibleEN"
            label="Tags visibles"
            multiple
            chips
            item-text="name"
            return-object
            clearable
            deletable-chips
            hide-selected
                :rules="[required]"

            ><template v-slot:no-data>
              <v-list-item>
                <v-list-item-title>
                  Mot-clé inexistant. Appuyer sur Entrer pour
                  <strong>le créer</strong>
                </v-list-item-title>
              </v-list-item>
            </template></v-combobox
          >
        </div>
      </div>
      <div class="col-xl-6">
        <div class="form-group">
          <label><i class="la la-eye-slash"></i> Invisibles</label>

          <v-combobox
            v-model="video.keywords.invisibleEN"
            :items="keywords.invisibleEN"
            label="Tags invisibles"
            multiple
            chips
            item-text="name"
            return-object
            clearable
            deletable-chips
            hide-selected
                :rules="[required]"

            ><template v-slot:no-data>
              <v-list-item>
                <v-list-item-title>
                  Mot-clé inexistant. Appuyer sur Entrer pour
                  <strong>le créer</strong>
                </v-list-item-title>
              </v-list-item>
            </template></v-combobox
          >
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@import "@/assets/sass/pages/wizard/wizard-1.scss";
</style>

<script>
import Api from "@/core/services/api.service";

export default {
  name: "formVideoStep3",
  model: {
    prop: "video",
    event: "input",
  },
  props: {
    video: Object,
  },
  data: () => ({
    titleErrors: [
      (v) => !!v || "Le titre de la vidéo est obligatoire.",
      (v) => v.length >= 2 || "Le titre doit être supérieur à 2 caractères",
    ],
    descErrors: [
      (v) => !!v || "La description de la vidéo est obligatoire.",
      (v) =>
        v.length >= 2 || "La description doit être supérieure à 2 caractères",
    ],
    keywords: {
      visibleEN: [],
      invisibleEN: [],
    },
  }),

  //Les fonctions de Mounted sont appelées au lancement de la page automatiquement
  mounted() {
    this.getKeywords();
  },

  //les fonctions de Methods ne sont pas appelées au chargement de la page, il faut les appeler.
  methods: {
    required(value) {
      if (value instanceof Array && value.length == 0) {
        return "Vous devez choisir ou créer un mot-clé";
      }
      return !!value || "Vous devez choisir ou créer un mot-clé";
    },
    getKeywords() {
      Api.get("keywords").then((keywords) => {
        keywords.data["hydra:member"].forEach((keyword) => {
          if (keyword.isVisible == true) {
            if (keyword.lang === "EN") {
              // Je range tout les mots-clés dans un tableau pour savoir s'ils sont visibles ou non
              this.keywords.visibleEN.push(keyword);
            }
          } else {
            if (keyword.lang == "EN") {
              this.keywords.invisibleEN.push(keyword);
            }
          }
        });
      });
    },
  },
};
</script>
